exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#App[data-v-7ba5bd90] {\n  font-family: 'Asap', sans-serif;\n}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Frontend Parent (Prod)/ui/parents/src/App.vue"],"names":[],"mappings":";AAwBA;EACI,gCAA+B;CAClC","file":"App.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n#App {\n    font-family: 'Asap', sans-serif;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ba5bd90","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 3dj+
// module chunks = 21